import React from "react";

const Error = () => {
    const params = new URLSearchParams(window.location.search)
    const error_description = params.get('error_description') || '';

    return (
        <h1>Error: {error_description}</h1>
    )
};

export default Error;
